import { Button, Flex, Modal, Stack, Text } from "@mantine/core";
import { updateDuplicateIdea } from "../../../Api";
import { showNotification } from "@mantine/notifications";
import { useAuth0 } from "@auth0/auth0-react";
import AssignedIdeaInfo from "../right-bar/evidence-card/actions/MatchActions/AssignedIdeaInfo";
import { DuplicationType, DuplicationTypeLabels } from "../../../types/constants";

const DuplicateIdeaModal = ({
  duplicateIdea,
  duplicationId,
  duplicationType,
  verifyOpened,
  setVerifyOpened,
}: {
  duplicateIdea: any;
  duplicationId?: string;
  duplicationType?: DuplicationType;
  verifyOpened: boolean;
  setVerifyOpened: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const auth0 = useAuth0();
 
  const handleDuplicateIdea = () => {
    updateDuplicateIdea(duplicationId ||duplicateIdea?.duplicationId, auth0).then((res) => {
      if (res.status === 200) {
        showNotification({
          title: 'Success',
          message: 'Idea marked as not-a-duplication successfully',
        });
      }
      setVerifyOpened(false);
    })
  }

  return (
    <Modal
      yOffset={150}
      opened={verifyOpened}
      onClose={() => setVerifyOpened(false)}
      h="45vw"
      size="32vw"
    >
      <Stack mx="sm" mb={0}>
        <Stack mb={5} mt={-5}>
          <Text fz={14} mr={5} lineClamp={1}>
          There is a similar Idea that might be a duplication
          </Text>
          <Text fz={14}>
            <b>Reason:</b> "{DuplicationTypeLabels[duplicationType || duplicateIdea?.duplicationType as DuplicationType]}"
          </Text>
          <AssignedIdeaInfo assignedIdea={duplicateIdea} />
        </Stack>
        

        <Flex justify="space-around" style={{ width: "100%" }} mt={13} mb={13}>
          <Button
            mx="md"
            onClick={() => setVerifyOpened(false)}
            styles={(theme) => ({
              root: {
                height: "32px",
                backgroundColor: "#DB2525",
                fontWeight: 400,
                "&:hover": {
                  backgroundColor: theme.fn.darken("#DB2525", 0.05),
                },
              },
              leftIcon: {
                marginRight: 15,
              },
            })}
          >
            Cancel
          </Button>

          <Button
            mx="md"
            styles={(theme) => ({
              root: {
                height: "32px",
                backgroundColor: "#5C5CEB",
                fontWeight: 400,
                "&:hover": {
                  backgroundColor: theme.fn.darken("#5C5CEB", 0.05),
                },
              },
              leftIcon: {
                marginRight: 15,
              },
            })}
            onClick={() => handleDuplicateIdea()} 
          >
            Mark as not-a-duplication
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
};

export default DuplicateIdeaModal;
